import { deepFreeze } from "../util/misc";

export const QUOTE_SETTINGS = {
  preapproved: false,
  nonfinal: false,
  generalSpecs: "",
  terms: true,
  itemPrices: true,
  totalsFirst: true,
  totalsLast: true,
  removeLineBreaks: true,
  includePDF: false,
};
deepFreeze(QUOTE_SETTINGS);
